import { ReactNode } from 'react';

import s from './headerControls.module.scss';

type Props = {
  children: ReactNode;
};

const InfoItem = ({ children }: Props): JSX.Element => {
  return <li className={s.infoItem}>{children}</li>;
};

export default InfoItem;
